// extracted by mini-css-extract-plugin
export default {"titleSelect":"styles_titleSelect__u9EbV","error":"styles_error__I1RAa","enhanced":"styles_enhanced__V1Tzf","notice":"styles_notice__GRJih","pulse":"styles_pulse__hEX5S"};